module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


let itemsArray = Object.keys(items);

itemsArray.forEach(function(item, i) {
	let $item = items[item];
	;
__p += '\n\n	<div class="col-default-4 col-tablet-6 col-v-mobile-12">\n		<a href="' +
((__t = ( $item.url )) == null ? '' : __t) +
'" class="media-list__item">\n			<span class="media-list__preview" style="background-image: url(' +
((__t = ( $item.preview )) == null ? '' : __t) +
');"></span>\n			<span class="media-list__caption">\n				<span class="media-list__name">' +
((__t = ( $item.title )) == null ? '' : __t) +
'</span>\n				<span class="media-list__amount">' +
((__t = ( $item.amount )) == null ? '' : __t) +
'</span>\n			</span>\n		</a>\n	</div>\n\n	';

});
;


}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./frontend/components/media-list/media-list.ejs
// module id = 220
// module chunks = 0